// Arabic catalog for reports, POS, public portals/catalogs, and printable documents.
// Dynamic replacements deliberately preserve captured names, numbers, item data,
// dates, amounts, currencies, and document references.

export const reportsPosPublicTranslations: Record<string, string> = {
  // Reports workspace and report catalog
  'Reports': 'التقارير',
  'Workspace analytics': 'تحليلات مساحة العمل',
  'Analyze your business performance with real-time financial reports': 'حلّل أداء أعمالك من خلال تقارير مالية آنية',
  'Search reports...': 'ابحث في التقارير...',
  'Starred Reports': 'التقارير المفضلة',
  'Financial performance': 'الأداء المالي',
  'Financial statements': 'القوائم المالية',
  'Payables and receivables': 'الذمم الدائنة والمدينة',
  'Payroll': 'كشوف الرواتب',
  'Reconciliations': 'التسويات والمطابقات',
  'Taxes and balances': 'الضرائب والأرصدة',
  'Transactions': 'المعاملات',
  'Budget Manager': 'إدارة الموازنة',
  'Budget Variance': 'انحرافات الموازنة',
  'Budget Summary': 'ملخص الموازنة',
  'Executive Summary': 'الملخص التنفيذي',
  'Cash Summary': 'ملخص النقدية',
  'Tracking Summary': 'ملخص فئات التتبع',
  'Balance Sheet': 'قائمة المركز المالي',
  'Blank Report': 'تقرير فارغ',
  'Depreciation Schedule': 'جدول الإهلاك',
  'Disposal Schedule': 'جدول استبعادات الأصول',
  'Fixed Asset Reconciliation': 'تسوية الأصول الثابتة',
  'Management Report': 'التقرير الإداري',
  'Movements in Equity': 'قائمة التغيرات في حقوق الملكية',
  'Profit & Loss': 'الأرباح والخسائر',
  'Profit and Loss': 'قائمة الأرباح والخسائر',
  'Statement of Cash Flows': 'قائمة التدفقات النقدية',
  'Statement of Cash Flows - Direct Method': 'قائمة التدفقات النقدية - الطريقة المباشرة',
  'Aged Payables Detail': 'تفاصيل أعمار الذمم الدائنة',
  'Aged Payables Summary': 'ملخص أعمار الذمم الدائنة',
  'Aged Receivables Detail': 'تفاصيل أعمار الذمم المدينة',
  'Aged Receivables Summary': 'ملخص أعمار الذمم المدينة',
  'Aged Payables': 'أعمار الذمم الدائنة',
  'Aged Receivables': 'أعمار الذمم المدينة',
  'Billable Expenses - Outstanding': 'المصروفات القابلة للفوترة - المستحقة',
  'Contact Transactions - Summary': 'معاملات جهة الاتصال - ملخص',
  'Expense Claim Detail': 'تفاصيل مطالبات المصروفات',
  'Income and Expenses by Contact': 'الإيرادات والمصروفات حسب جهة الاتصال',
  'Payable Invoice Detail': 'تفاصيل فواتير الذمم الدائنة',
  'Payable Invoice Summary': 'ملخص فواتير الذمم الدائنة',
  'Receivable Invoice Detail': 'تفاصيل فواتير الذمم المدينة',
  'Receivable Invoice Summary': 'ملخص فواتير الذمم المدينة',
  'Pay Run by Employee': 'مسير الرواتب حسب الموظف',
  'Pay Run by Pay Item': 'مسير الرواتب حسب بند الراتب',
  'Pay Run by Pay Type': 'مسير الرواتب حسب نوع الراتب',
  'Pay Run Summary': 'ملخص مسير الرواتب',
  'Account Summary': 'ملخص الحساب',
  'Bank Reconciliation': 'التسوية البنكية',
  'Bank Summary': 'ملخص البنوك',
  'Cash Validation Customer Report': 'تقرير مطابقة نقدية العملاء',
  'Inventory Item List': 'قائمة أصناف المخزون',
  'Reconciliation Reports': 'تقارير التسوية',
  'Uncoded Statement Lines': 'بنود كشف الحساب غير المرمّزة',
  'Foreign Currency Gains and Losses': 'أرباح وخسائر فروق العملة',
  'General Ledger Detail': 'تفاصيل دفتر الأستاذ العام',
  'General Ledger Exceptions': 'استثناءات دفتر الأستاذ العام',
  'General Ledger Summary': 'ملخص دفتر الأستاذ العام',
  'General Ledger': 'دفتر الأستاذ العام',
  'Journal Report': 'تقرير قيود اليومية',
  'Sales Tax Report': 'تقرير ضريبة المبيعات',
  'Tax Reconciliation': 'التسوية الضريبية',
  'Trial Balance': 'ميزان المراجعة',
  'Account Transactions': 'حركات الحساب',
  'Duplicate Statement Lines': 'بنود كشف الحساب المكررة',
  'Inventory Item Summary': 'ملخص أصناف المخزون',
  'Sales by Item': 'المبيعات حسب الصنف',
  'Sales Team Performance': 'أداء فريق المبيعات',
  'Back to Reports': 'العودة إلى التقارير',
  'This report is currently being generated. Please check back soon.': 'يجري إعداد هذا التقرير حاليًا. يُرجى التحقق مرة أخرى قريبًا.',
  'Untitled Report': 'تقرير بلا عنوان',
  'Layout Editor': 'محرر تخطيط التقرير',
  'Create a report using the layout editor': 'أنشئ تقريرًا باستخدام محرر التخطيط',
  'Edit layout': 'تعديل التخطيط',
  'Drag to reorder columns': 'اسحب لإعادة ترتيب الأعمدة',
  'Close reorder columns dialog': 'إغلاق نافذة إعادة ترتيب الأعمدة',
  'Column order updated': 'تم تحديث ترتيب الأعمدة',
  'Star': 'إضافة إلى المفضلة',
  'Unstar': 'إزالة من المفضلة',

  // Report filters, options, headings, and table labels
  'Date range:': 'نطاق التاريخ:',
  'Date:': 'التاريخ:',
  'As of': 'حتى تاريخ',
  'As at': 'كما في',
  'For the period': 'عن الفترة',
  'For the month ended': 'عن الشهر المنتهي في',
  'For the year ended': 'عن السنة المنتهية في',
  'From': 'من',
  'To': 'إلى',
  'to': 'إلى',
  'Today': 'اليوم',
  'This month': 'هذا الشهر',
  'Last month': 'الشهر الماضي',
  'This quarter': 'هذا الربع',
  'This financial year': 'هذه السنة المالية',
  'End of this month': 'نهاية هذا الشهر',
  'End of last month': 'نهاية الشهر الماضي',
  'End of last quarter': 'نهاية الربع الماضي',
  'End of last financial year': 'نهاية السنة المالية الماضية',
  'Compare with': 'المقارنة مع',
  'Compare tracking categories': 'مقارنة فئات التتبع',
  'None': 'بدون',
  'Average': 'المتوسط',
  '1 month': 'شهر واحد',
  '2 months': 'شهران',
  '3 months': '3 أشهر',
  '4 months': '4 أشهر',
  '1 year': 'سنة واحدة',
  '2 years': 'سنتان',
  '3 years': '3 سنوات',
  '4 years': '4 سنوات',
  '0 Months': '0 شهر',
  '3 Months': '3 أشهر',
  '6 Months': '6 أشهر',
  '12 Months': '12 شهرًا',
  '24 Months': '24 شهرًا',
  'Filter': 'تصفية',
  'More': 'المزيد',
  'Show': 'إظهار',
  'Update': 'تحديث',
  'Update & Export': 'تحديث وتصدير',
  'Export': 'تصدير',
  'Print': 'طباعة',
  'Apply': 'تطبيق',
  'Cancel': 'إلغاء',
  'Accounting basis': 'الأساس المحاسبي',
  'Accrual': 'الاستحقاق',
  'Cash': 'النقدي',
  'Include accounts with': 'تضمين الحسابات ذات',
  'Zero balance or activity': 'رصيد أو حركة صفرية',
  'Account codes': 'رموز الحسابات',
  'Decimals': 'المنازل العشرية',
  'Columns': 'الأعمدة',
  '7 columns selected': 'تم تحديد 7 أعمدة',
  '16 account types selected': 'تم تحديد 16 نوع حساب',
  'Grouping/Summarizing': 'التجميع والتلخيص',
  'Group by Cost Account': 'تجميع حسب حساب التكلفة',
  'Reorder columns': 'إعادة ترتيب الأعمدة',
  'Account types': 'أنواع الحسابات',
  'Tracking category': 'فئة التتبع',
  'Tracking Option': 'خيار التتبع',
  'All Accounts': 'جميع الحسابات',
  'All Contacts': 'جميع جهات الاتصال',
  'All': 'الكل',
  'Account': 'الحساب',
  'Account Code': 'رمز الحساب',
  'Journal ID': 'معرّف القيد',
  'Posted Date': 'تاريخ الترحيل',
  'Posted By': 'رُحّل بواسطة',
  'Date': 'التاريخ',
  'Contact': 'جهة الاتصال',
  'Description': 'البيان',
  'Reference': 'المرجع',
  'Debit': 'مدين',
  'Credit': 'دائن',
  'Dr': 'مدين',
  'Cr': 'دائن',
  'Total': 'الإجمالي',
  'Totals': 'الإجماليات',
  'Net Total': 'صافي الإجمالي',
  'View': 'عرض',
  'No transactions found in this period.': 'لا توجد معاملات في هذه الفترة.',
  'No journals found for the selected period.': 'لا توجد قيود يومية للفترة المحددة.',
  'No inventory data available': 'لا تتوفر بيانات مخزون',
  'Warning: Trial balance is not equal. Difference: $': 'تحذير: ميزان المراجعة غير متوازن. الفرق: $',
  'Balanced': 'متوازن',
  'Unbalanced': 'غير متوازن',
  'Assets': 'الأصول',
  'Total Assets': 'إجمالي الأصول',
  'Liabilities': 'الالتزامات',
  'Total Liabilities': 'إجمالي الالتزامات',
  'Equity': 'حقوق الملكية',
  'Total Equity': 'إجمالي حقوق الملكية',
  'Total Liabilities & Equity': 'إجمالي الالتزامات وحقوق الملكية',
  'Opening Balance': 'الرصيد الافتتاحي',
  'Closing Balance': 'الرصيد الختامي',
  'Net Movement': 'صافي الحركة',
  'Net Profit': 'صافي الربح',
  'Other Movements': 'حركات أخرى',
  'Income': 'الإيرادات',
  'Other Income': 'إيرادات أخرى',
  'Revenue': 'الإيرادات',
  'Total Revenue': 'إجمالي الإيرادات',
  'Trading Income': 'إيرادات النشاط',
  'Total Income': 'إجمالي الإيرادات',
  'Direct Cost': 'التكلفة المباشرة',
  'Direct Costs': 'التكاليف المباشرة',
  'Cost of Sales': 'تكلفة المبيعات',
  'Less Cost of Sales': 'يطرح: تكلفة المبيعات',
  'Total Cost of Sales': 'إجمالي تكلفة المبيعات',
  'Total Direct Costs': 'إجمالي التكاليف المباشرة',
  'Gross Profit': 'مجمل الربح',
  'Expense': 'مصروف',
  'Expenses': 'المصروفات',
  'Operating Expenses': 'المصروفات التشغيلية',
  'Less Expenses': 'يطرح: المصروفات',
  'Total Expenses': 'إجمالي المصروفات',
  'Income vs Expenses': 'الإيرادات مقابل المصروفات',
  'Expense Breakdown': 'تحليل المصروفات',
  'No expenses recorded for this period.': 'لم تُسجل مصروفات لهذه الفترة.',
  'No expenses recorded.': 'لم تُسجل مصروفات.',
  'No income recorded.': 'لم تُسجل إيرادات.',
  'No direct costs recorded.': 'لم تُسجل تكاليف مباشرة.',
  'Item': 'الصنف',
  'Warehouse': 'المستودع',
  'Lot Number': 'رقم التشغيلة',
  'Expiry': 'تاريخ الانتهاء',
  'Qty on Hand': 'الكمية المتاحة',
  'Unit Cost': 'تكلفة الوحدة',
  'Value': 'القيمة',
  'Total Inventory Value': 'إجمالي قيمة المخزون',
  'Cost': 'التكلفة',
  'Opening Value': 'القيمة الافتتاحية',
  'Purchases': 'المشتريات',
  'Disposals': 'الاستبعادات',
  'Depreciation': 'الإهلاك',
  'Closing Value': 'القيمة الختامية',
  'Cash received': 'النقدية المحصلة',
  'Cash spent': 'النقدية المدفوعة',
  'Cash surplus (deficit)': 'فائض (عجز) النقدية',
  'Closing bank balance': 'الرصيد البنكي الختامي',
  'Profitability': 'الربحية',
  'Direct costs': 'التكاليف المباشرة',
  'Gross profit (loss)': 'مجمل الربح (الخسارة)',
  'Profit (loss)': 'صافي الربح (الخسارة)',
  'Debtors': 'المدينون',
  'Creditors': 'الدائنون',
  'Net assets': 'صافي الأصول',
  'Average (YTD)': 'المتوسط (منذ بداية السنة)',
  'Variance': 'الانحراف',
  'Surplus (Deficit)': 'الفائض (العجز)',
  'Summary': 'الملخص',
  'Plus Net Cash Movement': 'يضاف: صافي حركة النقدية',
  'Net Cash Flows': 'صافي التدفقات النقدية',
  'Cash and Cash Equivalents': 'النقدية وما في حكمها',
  'Cash and cash equivalents at beginning of period': 'النقدية وما في حكمها في بداية الفترة',
  'Cash and cash equivalents at end of period': 'النقدية وما في حكمها في نهاية الفترة',
  'Tax on operating activities': 'الضريبة على الأنشطة التشغيلية',
  'Gross': 'إجمالي',
  'Net': 'صافي',
  'User Name': 'اسم المستخدم',
  'Total Earned': 'إجمالي المحصل',
  'Total Spent': 'إجمالي المنفق',
  'Net Contribution': 'صافي المساهمة',
  'Receivable': 'ذمم مدينة',
  'Receivables': 'الذمم المدينة',
  'Payable': 'ذمم دائنة',
  'Payables': 'الذمم الدائنة',
  'Current': 'الحالي',

  // Budgets
  'Budget': 'الموازنة',
  'Actual': 'الفعلي',
  'Actuals': 'الفعليات',
  'Hide Actuals': 'إخفاء الفعليات',
  'Show Actuals': 'إظهار الفعليات',
  'Select Budget': 'اختر موازنة',
  '+ Add new budget': '+ إضافة موازنة جديدة',
  'Create New Budget': 'إنشاء موازنة جديدة',
  'New Budget': 'موازنة جديدة',
  'Budget Name': 'اسم الموازنة',
  'e.g. 2026 Growth Plan': 'مثال: خطة النمو 2026',
  'Create Budget': 'إنشاء الموازنة',
  'Save Budget': 'حفظ الموازنة',
  'Start': 'البداية',
  'Period': 'الفترة',
  'Future Periods to Show': 'الفترات المستقبلية المطلوب إظهارها',
  'Overall Budget': 'الموازنة الإجمالية',
  'Var %': 'نسبة الانحراف',
  'Unable to load budgets': 'تعذر تحميل الموازنات',
  'Unable to update budget': 'تعذر تحديث الموازنة',
  'Unable to create budget': 'تعذر إنشاء الموازنة',
  'Could not save budget': 'تعذر حفظ الموازنة',
  'Could not create budget': 'تعذر إنشاء الموازنة',
  'Budget saved successfully': 'تم حفظ الموازنة بنجاح',
  'New budget created': 'تم إنشاء الموازنة الجديدة',

  // Executive dashboard
  'Insights': 'الرؤى التحليلية',
  'Executive Dashboard': 'لوحة المعلومات التنفيذية',
  'Live Data Active': 'البيانات المباشرة مفعّلة',
  'Quick Action': 'إجراء سريع',
  'Done Editing': 'إنهاء التعديل',
  'Edit Layout': 'تعديل التخطيط',
  'Mode': 'الوضع',
  'Layout Customization': 'تخصيص التخطيط',
  'Instructions': 'التعليمات',
  'Drag widgets • Tap Eye to toggle': 'اسحب الأدوات • اضغط رمز العين للتبديل',
  'Finish': 'إنهاء',
  'Review': 'مراجعة',
  'Revenue · This Month': 'الإيرادات · هذا الشهر',
  'Bills · This Month': 'فواتير المشتريات · هذا الشهر',
  'vs': 'مقابل',
  'Pending Invoices': 'فواتير المبيعات المعلقة',
  'Awaiting customer payment': 'بانتظار سداد العميل',
  'Pending Bills': 'فواتير المشتريات المعلقة',
  'Awaiting your payment': 'بانتظار السداد',
  'Operational Performance': 'الأداء التشغيلي',
  'Cash In/Out Maturity': 'استحقاقات التدفقات النقدية الداخلة والخارجة',
  'Liquidity & Solvency': 'السيولة والملاءة المالية',
  'Current Liquidity': 'السيولة الحالية',
  'Burn Ratio': 'معدل استهلاك النقدية',
  'Key Financial Ratios': 'النسب المالية الرئيسية',
  'Current Ratio': 'نسبة التداول',
  '> 1.0 Is Good': 'أكبر من 1.0 مؤشر جيد',
  'Debt to Equity': 'نسبة الدين إلى حقوق الملكية',
  'Healthy Leverage': 'رافعة مالية سليمة',
  'Gross Margin': 'هامش مجمل الربح',
  'Direct Profitability': 'الربحية المباشرة',
  'Net Margin': 'هامش صافي الربح',
  'Bottom Line Profit': 'صافي الربح النهائي',
  'DSO': 'متوسط فترة التحصيل',
  'DPO': 'متوسط فترة السداد',
  'Days': 'أيام',
  'Sales Outstanding': 'أيام المبيعات المستحقة',
  'Payables Outstanding': 'أيام الذمم الدائنة المستحقة',
  'EBITDA Waterfall Bridge': 'تحليل جسر الأرباح قبل الفوائد والضرائب والإهلاك والاستهلاك',
  'Profitability Flow': 'تدرج الربحية',
  'Category': 'الفئة',
  'Trend': 'الاتجاه',
  'Amount': 'المبلغ',
  '% of Total': '٪ من الإجمالي',
  'Contact Name': 'اسم جهة الاتصال',
  'Creation Date': 'تاريخ الإنشاء',
  'Due Date': 'تاريخ الاستحقاق',
  'No pending invoices': 'لا توجد فواتير مبيعات معلقة',
  'Pending Bills (To Pay Suppliers)': 'فواتير مشتريات معلقة (مستحقات الموردين)',
  'Supplier Name': 'اسم المورد',
  'No pending bills': 'لا توجد فواتير مشتريات معلقة',
  'Financial Health Monitor': 'مراقب الصحة المالية',
  'Code': 'الرمز',
  'This Month': 'هذا الشهر',
  'Year to Date': 'منذ بداية السنة',
  'No accounts added to watchlist': 'لم تُضف حسابات إلى قائمة المراقبة',
  'Go to Chart of Accounts and check "Show on Dashboard Watchlist"': 'انتقل إلى دليل الحسابات وحدد «إظهار في قائمة مراقبة لوحة المعلومات»',
  'Active Sessions': 'الجلسات النشطة',
  'Users currently checked in across organizations': 'المستخدمون المسجل حضورهم حاليًا عبر المؤسسات',
  'Alerts & Anomalies': 'التنبيهات والحالات غير الاعتيادية',
  'Total Revenue KPI': 'مؤشر إجمالي الإيرادات',
  'Total Bills KPI': 'مؤشر إجمالي فواتير المشتريات',
  'Pending Invoices KPI': 'مؤشر فواتير المبيعات المعلقة',
  'Pending Bills KPI': 'مؤشر فواتير المشتريات المعلقة',
  'Profit & Loss Overview': 'نظرة عامة على الأرباح والخسائر',
  'Cash In/Out Flow': 'التدفقات النقدية الداخلة والخارجة',
  'Top Customers': 'أهم العملاء',
  'Top Expense Categories': 'أعلى فئات المصروفات',
  'Pending Invoices List': 'قائمة فواتير المبيعات المعلقة',
  'Pending Bills List (Suppliers)': 'قائمة فواتير المشتريات المعلقة (الموردون)',
  'Financial Ratios & Metrics': 'النسب والمقاييس المالية',
  'Budget vs Actual Variance': 'انحراف الموازنة عن الفعلي',
  'EBITDA Waterfall': 'تحليل الأرباح قبل الفوائد والضرائب والإهلاك والاستهلاك',
  'Account Watchlist': 'قائمة مراقبة الحسابات',
  'Recent Contacts': 'جهات الاتصال الحديثة',
  'Attendance Center': 'مركز الحضور',
  'Task Management': 'إدارة المهام',
  'Create Quotation': 'إنشاء عرض سعر',
  'Create Invoice': 'إنشاء فاتورة مبيعات',
  'Create Purchase Order': 'إنشاء أمر شراء',
  'Create Bill': 'إنشاء فاتورة مشتريات',
  'Create Manual Journal': 'إنشاء قيد يومية يدوي',
  'Create Item': 'إنشاء صنف',
  'Create Contact': 'إنشاء جهة اتصال',
  'Create Task': 'إنشاء مهمة',
  'Visible': 'ظاهر',
  'Hidden': 'مخفي',
  'Unknown Customer': 'عميل غير معروف',
  'Unknown Supplier': 'مورد غير معروف',
  'General Expense': 'مصروف عام',
  'Other Payments': 'مدفوعات أخرى',
  'Pending': 'قيد الانتظار',
  'To Do': 'مطلوب التنفيذ',
  'In Progress': 'قيد التنفيذ',
  'Completed': 'مكتمل',
  'Done': 'منجز',

  // POS sell screen and sales history
  'POS': 'نقطة البيع',
  'Select Store': 'اختر المتجر',
  'Please select the physical store you are operating from.': 'يُرجى اختيار المتجر الفعلي الذي تعمل منه.',
  'Keep Current Selection': 'الإبقاء على الاختيار الحالي',
  'Search Products': 'البحث عن المنتجات',
  'Search or scan...': 'ابحث أو امسح الرمز...',
  'Custom Item Name': 'اسم الصنف المخصص',
  'Product Name': 'اسم المنتج',
  'Sale': 'سعر البيع',
  'Add to Cart': 'إضافة إلى السلة',
  'Scan Barcode': 'مسح الباركود',
  'Parked Invoices': 'الفواتير المعلّقة',
  'Enter Barcode / SKU': 'أدخل الباركود أو رمز الصنف',
  'Barcode...': 'الباركود...',
  'No POS-enabled items found.': 'لم يتم العثور على أصناف مفعّلة لنقطة البيع.',
  'SKU:': 'رمز الصنف:',
  'Out of Stock': 'نفد المخزون',
  'Operating From': 'المتجر الحالي',
  'Change': 'تغيير',
  'Return Mode Active': 'وضع المرتجعات مفعّل',
  'Customer': 'العميل',
  'Clear All': 'مسح الكل',
  'Clear': 'مسح',
  'Add New Customer': 'إضافة عميل جديد',
  'Customer Name': 'اسم العميل',
  'Full Name': 'الاسم الكامل',
  'Phone Number': 'رقم الهاتف',
  'Phone': 'الهاتف',
  'Save Customer': 'حفظ العميل',
  'Cart Items': 'أصناف السلة',
  'Your cart is empty.': 'سلة البيع فارغة.',
  'Select items to start selling.': 'اختر أصنافًا لبدء البيع.',
  'Qty:': 'الكمية:',
  'Edit Item': 'تعديل الصنف',
  'Delete Item': 'حذف الصنف',
  'Note:': 'ملاحظة:',
  'Discount:': 'الخصم:',
  'off': 'خصم',
  '| Lot:': '| التشغيلة:',
  'Order Notes': 'ملاحظات الطلب',
  'Add notes to this order...': 'أضف ملاحظات إلى هذا الطلب...',
  'Global Discount': 'خصم إجمالي',
  'Subtotal': 'الإجمالي الفرعي',
  'Discount': 'الخصم',
  'Tax': 'الضريبة',
  'Sale Successful!': 'تمت عملية البيع بنجاح!',
  'Transaction has been recorded.': 'تم تسجيل المعاملة.',
  'Print Receipt': 'طباعة الإيصال',
  'History & Notes': 'السجل والملاحظات',
  'Park': 'تعليق عملية البيع',
  'Refund Total': 'إجمالي المبلغ المسترد',
  'Pay & Check-out': 'الدفع وإتمام البيع',
  'Edit Line Item': 'تعديل بند البيع',
  'Line Total': 'إجمالي البند',
  'Quantity': 'الكمية',
  'Unit Price': 'سعر الوحدة',
  'Percent': 'نسبة مئوية',
  'Line Notes': 'ملاحظات البند',
  'Add specific instructions for this item...': 'أضف تعليمات خاصة بهذا الصنف...',
  'Apply Changes': 'تطبيق التغييرات',
  'Add Item': 'إضافة صنف',
  'Select Warehouse': 'اختر المستودع',
  'Auto (Newest)': 'تلقائي (الأحدث)',
  'Expiry Date': 'تاريخ الانتهاء',
  'Refund': 'استرداد',
  'Check-out': 'إتمام البيع',
  'Payment Method': 'طريقة الدفع',
  'Bank': 'بنك',
  'No payment methods available for this store.': 'لا تتوفر طرق دفع لهذا المتجر.',
  'Refund Amount': 'مبلغ الاسترداد',
  'Amount Paid': 'المبلغ المدفوع',
  'Total Amount:': 'المبلغ الإجمالي:',
  'Already Paid:': 'المدفوع سابقًا:',
  'Remaining Balance:': 'الرصيد المتبقي:',
  'Confirm Refund': 'تأكيد الاسترداد',
  'Confirm Payment': 'تأكيد الدفع',
  'Parked Invoices from POS': 'الفواتير المعلّقة من نقطة البيع',
  'Total Amount': 'المبلغ الإجمالي',
  'Resume Sale': 'استئناف عملية البيع',
  'Delete Parked Invoice': 'حذف الفاتورة المعلّقة',
  'No parked invoices': 'لا توجد فواتير معلّقة',
  'Invoices parked during checkout will appear here.': 'ستظهر هنا الفواتير التي عُلّقت أثناء إتمام البيع.',
  'Close': 'إغلاق',
  'Please select a customer to complete the checkout.': 'يُرجى اختيار عميل لإتمام عملية البيع.',
  'Please allow popups to print receipts': 'يُرجى السماح بالنوافذ المنبثقة لطباعة الإيصالات',
  'Unable to complete sale.': 'تعذر إتمام عملية البيع.',
  'You do not have permission to apply discounts.': 'ليست لديك صلاحية تطبيق الخصومات.',
  'Paid': 'مدفوع',
  'Parked': 'معلّق',
  'Awaiting Payment': 'بانتظار السداد',
  'Walk-in Customer': 'عميل نقدي',
  'Unknown User': 'مستخدم غير معروف',
  'Unknown Item': 'صنف غير معروف',
  'Payment Received': 'تم استلام الدفعة',
  'Updated': 'محدّث',
  'No Email': 'لا يوجد بريد إلكتروني',
  'Document updated via Point of Sale': 'تم تحديث المستند عبر نقطة البيع',
  'Document created via Point of Sale': 'تم إنشاء المستند عبر نقطة البيع',
  'POS Sale Completed': 'اكتملت عملية بيع نقطة البيع',
  'POS Sale Updated': 'تم تحديث عملية بيع نقطة البيع',
  'STORE RECEIPT': 'إيصال المتجر',
  'RECEIPT': 'إيصال',
  'GIFT RECEIPT': 'إيصال هدية',
  'Order #': 'طلب رقم ',
  'Gift Receipt': 'إيصال هدية',
  'No prices shown': 'الأسعار غير ظاهرة',
  'Items:': 'الأصناف:',
  'Thank you for your business!': 'شكرًا لتعاملك معنا!',

  // POS sales history
  'Sales history': 'سجل المبيعات',
  'All Stores': 'جميع المتاجر',
  'Proceed Returns': 'تنفيذ المرتجعات',
  'Continuous Sell': 'متابعة البيع',
  'Choose date range...': 'اختر نطاق التاريخ...',
  'Clear dates': 'مسح التواريخ',
  'Time range': 'النطاق الزمني',
  'Choose a time range': 'اختر نطاقًا زمنيًا',
  'Clear times': 'مسح الأوقات',
  'Enter a customer': 'أدخل اسم عميل',
  'Receipt or note': 'الإيصال أو الملاحظة',
  'Enter a receipt or note': 'أدخل رقم إيصال أو ملاحظة',
  'Sold by': 'تم البيع بواسطة',
  'All Salespeople': 'جميع مندوبي المبيعات',
  'Status': 'الحالة',
  'All Statuses': 'جميع الحالات',
  'Return and Paid': 'مرتجع ومدفوع',
  'Sales (All Paid)': 'المبيعات (مدفوعة بالكامل)',
  'Awaiting (Return)': 'بانتظار الإرجاع',
  'Fulfillment Status': 'حالة تنفيذ الطلب',
  'All Fulfillment Statuses': 'جميع حالات تنفيذ الطلب',
  'Ready to Pick Up': 'جاهز للاستلام',
  'Out for Delivery': 'خرج للتوصيل',
  'Delivered': 'تم التسليم',
  'Canceled': 'ملغى',
  'Cancelled': 'ملغى',
  'Tag': 'وسم',
  'Search by tag...': 'ابحث بالوسم...',
  'Min': 'الحد الأدنى',
  'Max': 'الحد الأقصى',
  'Clear filters': 'مسح عوامل التصفية',
  'Less filters': 'عوامل تصفية أقل',
  'More filters': 'عوامل تصفية إضافية',
  'Search': 'بحث',
  'Displaying': 'عرض',
  'sales': 'عمليات بيع',
  'Export list': 'تصدير القائمة',
  'Receipt': 'الإيصال',
  'Store': 'المتجر',
  'Sale total': 'إجمالي البيع',
  'Fulfillment': 'تنفيذ الطلب',
  'Loading sales history...': 'جاري تحميل سجل المبيعات...',
  'No sales found matching your criteria.': 'لا توجد مبيعات مطابقة لمعايير البحث.',
  'Fulfillment status updated': 'تم تحديث حالة تنفيذ الطلب',
  'Return': 'مرتجع',
  'Sale details': 'تفاصيل عملية البيع',
  'Sold by:': 'تم البيع بواسطة:',
  'No notes for this sale.': 'لا توجد ملاحظات لعملية البيع هذه.',
  'Total tax (No Tax)': 'إجمالي الضريبة (دون ضريبة)',
  'SALE TOTAL': 'إجمالي البيع',
  'Credit card': 'بطاقة ائتمان',
  'Balance': 'الرصيد',
  'Return items': 'إرجاع الأصناف',
  'Edit': 'تعديل',
  'Gift receipt': 'إيصال هدية',
  'Email receipt': 'إرسال الإيصال بالبريد الإلكتروني',
  'WhatsApp receipt': 'إرسال الإيصال عبر واتساب',
  'Print receipt...': 'طباعة الإيصال...',
  'Void': 'إبطال',
  'Voided': 'مُبطل',
  'Edit sale on receipt': 'تعديل عملية البيع في الإيصال',
  'Any changes made on this sale will automatically update your sales and payments reports.': 'ستُحدّث أي تغييرات على عملية البيع هذه تقارير المبيعات والمدفوعات تلقائيًا.',
  'Sale date': 'تاريخ البيع',
  'Sale note': 'ملاحظة البيع',
  'Enter a note for this sale': 'أدخل ملاحظة لعملية البيع',
  '2000 characters max': 'الحد الأقصى 2000 حرف',
  'Payment type': 'نوع الدفع',
  'Select Payment Method': 'اختر طريقة الدفع',
  'Save changes': 'حفظ التغييرات',
  'A store is required to return this sale': 'يلزم تحديد متجر لإرجاع عملية البيع',
  'Returned from POS sales history': 'مرتجع من سجل مبيعات نقطة البيع',
  'Sale returned successfully; refund journal was already posted': 'تم إرجاع عملية البيع بنجاح؛ وكان قيد الاسترداد مُرحّلًا بالفعل',
  'Sale returned successfully': 'تم إرجاع عملية البيع بنجاح',
  'Failed to return sale': 'تعذر إرجاع عملية البيع',
  'Failed to post refund journal': 'تعذر ترحيل قيد الاسترداد',
  'Sale voided successfully': 'تم إبطال عملية البيع بنجاح',
  'Failed to void sale': 'تعذر إبطال عملية البيع',
  'Sale updated successfully': 'تم تحديث عملية البيع بنجاح',
  'Failed to update sale': 'تعذر تحديث عملية البيع',
  'Returned': 'مرتجع',
  'Returned/Paid': 'مرتجع/مدفوع',
  'Returned/Awaiting payment': 'مرتجع/بانتظار السداد',
  'Sales': 'المبيعات',
  'Deleted': 'محذوف',

  // POS catalog and inventory actions
  'Search catalog by name, code or barcode...': 'ابحث في الكتالوج بالاسم أو الرمز أو الباركود...',
  'Scan': 'مسح',
  'POS Enabled Products': 'منتجات مفعّلة لنقطة البيع',
  'Catalog Landing Page QR': 'رمز QR لصفحة الكتالوج',
  'Loading POS catalog...': 'جاري تحميل كتالوج نقطة البيع...',
  'No products found matching your search.': 'لا توجد منتجات مطابقة لبحثك.',
  'No POS-enabled products found. Enable products for POS in the Items module.': 'لا توجد منتجات مفعّلة لنقطة البيع. فعّل المنتجات من وحدة الأصناف.',
  'Generate QR Menu Code': 'إنشاء رمز QR للقائمة الرقمية',
  'Digital Menu QR': 'رمز QR للقائمة الرقمية',
  'QR Code': 'رمز QR',
  'Scan to view Digital Menu': 'امسح الرمز لعرض القائمة الرقمية',
  'High resolution PNG format': 'صيغة PNG عالية الدقة',
  'Download QR': 'تنزيل رمز QR',
  'Edit Product': 'تعديل المنتج',
  'Product Details': 'تفاصيل المنتج',
  'Barcode': 'الباركود',
  'N/A': 'غير متاح',
  'Category / Family': 'الفئة / العائلة',
  'Product ID': 'معرّف المنتج',
  'Pricing': 'التسعير',
  'Cost Price': 'سعر التكلفة',
  'Sell Price': 'سعر البيع',
  'Margin': 'هامش الربح',
  'Barcode Label': 'ملصق الباركود',
  'Label Settings': 'إعدادات الملصق',
  'Show Name': 'إظهار الاسم',
  'Show Price': 'إظهار السعر',
  'Show Code': 'إظهار الرمز',
  'Short': 'قصير',
  'Medium': 'متوسط',
  'Tall': 'طويل',
  'No barcode assigned to this product.': 'لم يُعيّن باركود لهذا المنتج.',
  'System Info': 'معلومات النظام',
  'Created By': 'أنشأه',
  'Created At': 'تاريخ الإنشاء',
  'Inventory Rules': 'قواعد المخزون',
  'Allow Negative Stock': 'السماح بالمخزون السالب',
  'Has Expiry Tracking': 'تتبّع تاريخ الانتهاء',
  'Store Availability': 'التوفر حسب المتجر',
  'Transfer Stock': 'تحويل مخزون',
  'Single Stock Take': 'جرد مخزون منفرد',
  'Write Off': 'إهلاك مخزون',
  'units': 'وحدات',
  'Stock on Hand': 'المخزون المتاح',
  'Stock Log': 'سجل المخزون',
  'Type': 'النوع',
  'Stock After': 'الرصيد بعد الحركة',
  'By': 'بواسطة',
  'No stock movements recorded for this view.': 'لم تُسجل حركات مخزون في هذا العرض.',
  'Write Off Stock': 'إهلاك المخزون',
  'Target Store': 'المتجر المستهدف',
  'Select target store...': 'اختر المتجر المستهدف...',
  'New Total Stock': 'إجمالي المخزون الجديد',
  'Note / Reason': 'ملاحظة / سبب',
  'Enter reason for this action...': 'أدخل سبب هذا الإجراء...',
  'Confirm Transfer': 'تأكيد التحويل',
  'Confirm Write Off': 'تأكيد الإهلاك',
  'Apply Adjustment': 'تطبيق التسوية',
  'Edit POS Product': 'تعديل منتج نقطة البيع',
  'Basic Information': 'المعلومات الأساسية',
  'Product Image (Max 3MB)': 'صورة المنتج (بحد أقصى 3 ميجابايت)',
  'Preview': 'معاينة',
  'Uploading...': 'جاري الرفع...',
  'Change Image': 'تغيير الصورة',
  'Upload Image': 'رفع صورة',
  'Supported formats: JPG, PNG, WEBP. Max size 3MB.': 'الصيغ المدعومة: JPG وPNG وWEBP. الحد الأقصى 3 ميجابايت.',
  'Select Category': 'اختر الفئة',
  'Ingredients / Components (comma separated)': 'المكونات (مفصولة بفواصل)',
  'e.g. Flour, Sugar, Milk': 'مثال: دقيق، سكر، حليب',
  'Sale Price (EGP)': 'سعر البيع (EGP)',
  'Cost Price (EGP)': 'سعر التكلفة (EGP)',
  'POS Modules & Settings': 'وحدات وإعدادات نقطة البيع',
  'Hide from Sell Screen': 'إخفاء من شاشة البيع',
  'Has Expiry Date': 'له تاريخ انتهاء',
  'Tags (comma separated)': 'الوسوم (مفصولة بفواصل)',
  'e.g. New, Popular, Sale': 'مثال: جديد، رائج، تخفيض',
  'Recipe Management': 'إدارة الوصفات',
  'Recipes': 'الوصفات',
  '+ Add New Recipe': '+ إضافة وصفة جديدة',
  'Recipe Name (e.g. Standard, Premium)': 'اسم الوصفة (مثال: قياسية، مميزة)',
  'Active': 'نشط',
  'Components': 'المكونات',
  '+ Add Component': '+ إضافة مكوّن',
  'Select Item': 'اختر صنفًا',
  'Qty': 'الكمية',
  'UOM': 'وحدة القياس',
  'Enable Variants': 'تفعيل المتغيرات',
  'Options': 'الخيارات',
  '+ Add Option': '+ إضافة خيار',
  'Option Name (e.g. Color, Size)': 'اسم الخيار (مثال: اللون، المقاس)',
  'Add value and press Enter...': 'أضف قيمة واضغط Enter...',
  'Generate Variants': 'إنشاء المتغيرات',
  'Generated Variants': 'المتغيرات المنشأة',
  'Save': 'حفظ',
  'Variant': 'المتغير',
  'Sell': 'البيع',
  'Save Changes': 'حفظ التغييرات',
  'Catalog Landing Page': 'صفحة الكتالوج',
  'Scan for Website Access': 'امسح الرمز لفتح الموقع',
  'This QR code links directly to your public product catalog website where customers can view all details.': 'يرتبط رمز QR مباشرة بموقع كتالوج المنتجات العام حيث يمكن للعملاء عرض جميع التفاصيل.',
  'Image size must be less than 3MB': 'يجب ألا يتجاوز حجم الصورة 3 ميجابايت',
  'Image uploaded successfully': 'تم رفع الصورة بنجاح',
  'Upload failed': 'تعذر الرفع',
  'Product updated successfully': 'تم تحديث المنتج بنجاح',
  'Failed to update product': 'تعذر تحديث المنتج',
  'Could not update item': 'تعذر تحديث الصنف',
  'Quantity must be greater than 0': 'يجب أن تكون الكمية أكبر من صفر',
  'Source and target stores must be different': 'يجب أن يختلف المتجر المصدر عن المتجر المستهدف',
  'Please select a target store': 'يُرجى اختيار المتجر المستهدف',
  'Insufficient stock in source store': 'المخزون غير كافٍ في المتجر المصدر',
  'Stock transferred successfully': 'تم تحويل المخزون بنجاح',
  'Stock written off successfully': 'تم إهلاك المخزون بنجاح',
  'Stock adjusted successfully': 'تمت تسوية المخزون بنجاح',
  'Failed to process stock action': 'تعذر تنفيذ حركة المخزون',
  'Could not process stock action': 'تعذر تنفيذ حركة المخزون',
  'Failed to generate QR code': 'تعذر إنشاء رمز QR',
  'Failed to connect to QR server': 'تعذر الاتصال بخادم رمز QR',

  // Public catalog and digital menu
  'Synchronizing Assets': 'جاري مزامنة المحتوى',
  'Fetching catalogs, refining visuals, and': 'جاري جلب الكتالوجات وتحسين العرض،',
  'preparing your experience...': 'وتجهيز تجربتك...',
  'CATALOG': 'الكتالوج',
  'SHOP': 'تسوّق',
  'VISION': 'رؤيتنا',
  'ARCHIVE': 'الأرشيف',
  'BAG_': 'السلة_',
  'UNITS': 'وحدات',
  'The Collection': 'المجموعة',
  'A curation of architectural silhouettes and technical foundations for the modern landscape.': 'تشكيلة منتقاة تجمع الخطوط المعمارية والأسس التقنية لأسلوب عصري.',
  'Explore Collection': 'استكشف المجموعة',
  'AVAILABILITY & ARCHIVE': 'التوفر والأرشيف',
  'Fixed quantities. Weekly releases. Items of high desire are archived once sold out.': 'كميات محدودة وإصدارات أسبوعية. تُنقل الأصناف الأعلى طلبًا إلى الأرشيف عند نفادها.',
  'SEARCH CATALOG_': 'ابحث في الكتالوج_',
  'Price.Point': 'السعر',
  'CONTACT FOR PRICE': 'تواصل لمعرفة السعر',
  'Empty.Manifest': 'القائمة فارغة',
  'No products matching your requirements': 'لا توجد منتجات مطابقة لمتطلباتك',
  'Description_': 'الوصف_',
  'A foundational piece engineered for versatility and resilience. Technical fabrications meet architectural tailoring.': 'قطعة أساسية صُممت لتعدد الاستخدامات والمتانة، تجمع الخامات التقنية مع التصميم المعماري.',
  'Authenticity_Check': 'التحقق من الأصالة',
  'Product link copied!': 'تم نسخ رابط المنتج!',
  'Copied': 'تم النسخ',
  'Copy Link': 'نسخ الرابط',
  'Hide QR': 'إخفاء رمز QR',
  'Show QR': 'إظهار رمز QR',
  'Add to Bag': 'إضافة إلى السلة',
  'Scan to view Product Landing Page_': 'امسح الرمز لعرض صفحة المنتج_',
  'Shopping.Bag': 'سلة التسوق',
  'Your bag is currently empty': 'سلة التسوق فارغة حاليًا',
  'Subtotal_': 'الإجمالي الفرعي_',
  'Check_Out': 'إتمام الطلب',
  'Information_': 'معلومات_',
  'Archive': 'الأرشيف',
  'Stockists': 'نقاط البيع',
  'Terms & Conditions': 'الشروط والأحكام',
  'Privacy Policy': 'سياسة الخصوصية',
  'System_Status': 'حالة النظام',
  'Petals Active': 'الخدمة نشطة',
  'Core Online': 'النظام متصل',
  'VERSION': 'الإصدار',
  'Your bag is empty.': 'سلة التسوق فارغة.',
  'Checkout is temporarily unavailable. Please contact us directly.': 'إتمام الطلب غير متاح مؤقتًا. يُرجى التواصل معنا مباشرة.',
  '*New Order Inquiry*': '*استفسار عن طلب جديد*',
  '*Items:*': '*الأصناف:*',
  'I would like to proceed with this order.': 'أرغب في متابعة هذا الطلب.',
  'Dish not found': 'لم يتم العثور على المنتج',
  'Product not found': 'لم يتم العثور على المنتج',
  'Try Again': 'إعادة المحاولة',
  'Go Back': 'رجوع',
  'Menu Item': 'صنف من القائمة',
  'EGP': 'EGP',
  'No description provided for this item.': 'لا يتوفر وصف لهذا الصنف.',
  'Components / Ingredients': 'المكونات',
  'Saved to Favorites': 'تم الحفظ في المفضلة',
  'Save Dish': 'حفظ المنتج',
  'Link copied to clipboard!': 'تم نسخ الرابط إلى الحافظة!',

  // Public quote and invoice portals
  'Client Portal': 'بوابة العميل',
  'Invoice': 'فاتورة مبيعات',
  'Quote': 'عرض سعر',
  'Quotation': 'عرض سعر',
  'Loading Invoice...': 'جاري تحميل الفاتورة...',
  'Loading Quote...': 'جاري تحميل عرض السعر...',
  'Something went wrong': 'حدث خطأ ما',
  'Invoice not found': 'لم يتم العثور على الفاتورة',
  'Quote not found': 'لم يتم العثور على عرض السعر',
  'Error fetching invoice': 'تعذر جلب الفاتورة',
  'Error fetching quote': 'تعذر جلب عرض السعر',
  'Invalid document type': 'نوع المستند غير صالح',
  'This invoice link might be invalid or expired.': 'قد يكون رابط الفاتورة غير صالح أو منتهي الصلاحية.',
  'This quote link might be invalid or expired.': 'قد يكون رابط عرض السعر غير صالح أو منتهي الصلاحية.',
  'Print Invoice': 'طباعة الفاتورة',
  'Print Quote': 'طباعة عرض السعر',
  'Download PDF': 'تنزيل PDF',
  'This invoice is currently': 'حالة الفاتورة حاليًا',
  'This quote is currently': 'حالة عرض السعر حاليًا',
  'Sent': 'مُرسل',
  'Accepted': 'مقبول',
  'Declined': 'مرفوض',
  'Decline': 'رفض',
  'Accept Quote': 'قبول عرض السعر',
  'Decline Quote': 'رفض عرض السعر',
  'Please add a reason for declining this quote.': 'يُرجى إضافة سبب لرفض عرض السعر.',
  'Reason for declining *': 'سبب الرفض *',
  'Tell us why this quote is being declined...': 'وضّح سبب رفض عرض السعر...',
  'Saving...': 'جاري الحفظ...',
  'Confirm Decline': 'تأكيد الرفض',
  'PDF downloaded successfully': 'تم تنزيل ملف PDF بنجاح',
  'Failed to generate PDF': 'تعذر إنشاء ملف PDF',
  'Bill To': 'فاتورة إلى',
  'Bill To:': 'فاتورة إلى:',
  'Attention': 'عناية',
  'Valued Customer': 'عميلنا الكريم',
  'Company Address': 'عنوان الشركة',
  'Issue Date:': 'تاريخ الإصدار:',
  'Due Date:': 'تاريخ الاستحقاق:',
  'Expiry Date:': 'تاريخ الانتهاء:',
  'Reference:': 'المرجع:',
  'Disc': 'الخصم',
  'Amount Due': 'المبلغ المستحق',
  'Payment Instructions': 'تعليمات الدفع',
  'Notes': 'ملاحظات',
  'Powered by Accountex Business Intelligence': 'مدعوم من Accountex Business Intelligence',
  'Terms of Service': 'شروط الخدمة',
  'Contact Support': 'التواصل مع الدعم',

  // Printable document and PDF-facing labels
  'INVOICE': 'فاتورة مبيعات',
  'QUOTATION': 'عرض سعر',
  'DELIVERY NOTE': 'إشعار تسليم',
  'PURCHASE ORDER': 'أمر شراء',
  'BILL': 'فاتورة مشتريات',
  'Logo': 'الشعار',
  'Your Company Name': 'اسم شركتك',
  'Company Address\nCity, Country': 'عنوان الشركة\nالمدينة، الدولة',
  'Phone:': 'الهاتف:',
  'Email:': 'البريد الإلكتروني:',
  'VAT:': 'الرقم الضريبي:',
  'Number': 'الرقم',
  'BILL TO': 'فاتورة إلى',
  'No address provided': 'لم يتم إدخال عنوان',
  'Customer VAT:': 'الرقم الضريبي للعميل:',
  'SHIP TO': 'الشحن إلى',
  'DESCRIPTION': 'البيان',
  'QUANTITY': 'الكمية',
  'UNIT PRICE': 'سعر الوحدة',
  'TAXES': 'الضرائب',
  'AMOUNT': 'المبلغ',
  'Unnamed Item': 'صنف بلا اسم',
  'Lot:': 'التشغيلة:',
  'SUBTOTAL': 'الإجمالي الفرعي',
  'TOTAL': 'الإجمالي',
  'AMOUNT DUE': 'المبلغ المستحق',
  'RECEIVER SIGNATURE': 'توقيع المستلم',
  'Signature': 'التوقيع',
  'Delivered on:': 'تم التسليم في:',
  'DELIVERY AUTHORIZATION': 'اعتماد التسليم',
  'Electronic System Signature': 'توقيع النظام الإلكتروني',
  'System Verified': 'تم التحقق بواسطة النظام',
  'NOTES & TERMS': 'الملاحظات والشروط',
  'Thank you for your business. Please pay within the due date.': 'شكرًا لتعاملك معنا. يُرجى السداد قبل تاريخ الاستحقاق.',
  'Secure QR': 'رمز QR آمن',
  'CERTIFIED ELECTRONIC DOCUMENT': 'مستند إلكتروني معتمد',
  'Your Company': 'شركتك',
};

const translatedDynamicStatus: Record<string, string> = {
  accepted: 'مقبول',
  awaiting: 'قيد الانتظار',
  'awaiting payment': 'بانتظار السداد',
  canceled: 'ملغى',
  cancelled: 'ملغى',
  completed: 'مكتمل',
  declined: 'مرفوض',
  deleted: 'محذوف',
  delivered: 'تم التسليم',
  draft: 'مسودة',
  paid: 'مدفوع',
  parked: 'معلّق',
  pending: 'قيد الانتظار',
  returned: 'مرتجع',
  sent: 'مُرسل',
  void: 'مُبطل',
  voided: 'مُبطل',
};

const statusInArabic = (status: string): string =>
  translatedDynamicStatus[status.trim().toLowerCase()] || status;

export const reportsPosPublicPatterns: Array<[RegExp, (...matches: string[]) => string]> = [
  // Report periods and parameterized report actions
  [/^As of\s+(.+)$/i, date => `حتى ${date}`],
  [/^As at\s+(.+)$/i, date => `كما في ${date}`],
  [/^For the month ended\s+(.+)$/i, date => `عن الشهر المنتهي في ${date}`],
  [/^For the year ended\s+(.+)$/i, date => `عن السنة المنتهية في ${date}`],
  [/^For the period\s+(.+)\s+to\s+(.+)$/i, (start, end) => `عن الفترة من ${start} إلى ${end}`],
  [/^From\s+(.+)\s+to\s+(.+)$/i, (start, end) => `من ${start} إلى ${end}`],
  [/^(\d+)\s+columns selected$/i, count => `تم تحديد ${count} عمود`],
  [/^(\d+)\s+account types selected$/i, count => `تم تحديد ${count} نوع حساب`],
  [/^(.+) exported successfully$/i, report => `تم تصدير ${report} بنجاح`],
  [/^Unstar\s+(.+)$/i, report => `إزالة ${report} من المفضلة`],
  [/^Star\s+(.+)$/i, report => `إضافة ${report} إلى المفضلة`],
  [/^More actions for\s+(.+)$/i, report => `إجراءات إضافية لـ ${report}`],
  [/^For\s+(.+)$/i, value => `لـ ${value}`],

  // POS quantities, documents, totals, and notifications
  [/^Discount must be between\s+(.+)%\s+and\s+(.+)%$/i, (minimum, maximum) => `يجب أن تتراوح نسبة الخصم بين ${minimum}٪ و${maximum}٪`],
  [/^(\d+)\s+POS Enabled Products$/i, count => `${count} منتج مفعّل لنقطة البيع`],
  [/^(\d+)\s+units$/i, count => `${count} وحدة`],
  [/^Qty:\s*(.+)$/i, quantity => `الكمية: ${quantity}`],
  [/^Order\s+#(.+)$/i, number => `طلب رقم ${number}`],
  [/^Receipt\s+#?(.+)$/i, number => `إيصال رقم ${number}`],
  [/^Gift Receipt\s+#?(.+)$/i, number => `إيصال هدية رقم ${number}`],
  [/^Date:\s*(.+)$/i, date => `التاريخ: ${date}`],
  [/^Items:\s*(.+)$/i, items => `الأصناف: ${items}`],
  [/^Subtotal:\s*(.+)$/i, amount => `الإجمالي الفرعي: ${amount}`],
  [/^Tax:\s*(.+)$/i, amount => `الضريبة: ${amount}`],
  [/^Total:\s*(.+)$/i, amount => `الإجمالي: ${amount}`],
  [/^Sale parked:\s*(.+)$/i, number => `تم تعليق عملية البيع: ${number}`],
  [/^Sale completed:\s*(.+)$/i, number => `اكتملت عملية البيع: ${number}`],
  [/^Resumed sale:\s*(.+)$/i, number => `تم استئناف عملية البيع: ${number}`],
  [/^Prepared return for:\s*(.+)$/i, number => `تم تجهيز مرتجع للفاتورة: ${number}`],
  [/^Deleted parked invoice:\s*(.+)$/i, number => `تم حذف الفاتورة المعلّقة: ${number}`],
  [/^Return for\s+(.+)$/i, number => `مرتجع للفاتورة ${number}`],
  [/^Receipt Number-(.+)$/i, number => `رقم الإيصال-${number}`],
  [/^Invoice Full Discount\s+\((.+)\)$/i, type => `خصم كامل على الفاتورة (${type})`],
  [/^Displaying\s+(.+)\s+sales$/i, count => `عرض ${count} عملية بيع`],
  [/^Sold by:\s*(.+)$/i, seller => `تم البيع بواسطة: ${seller}`],
  [/^Failed to upload image:\s*(.+)$/i, error => `تعذر رفع الصورة: ${error}`],
  [/^Update details for\s+(.+)$/i, product => `تحديث بيانات ${product}`],
  [/^Print Label\s+-\s+(.+)$/i, product => `طباعة ملصق - ${product}`],

  // Public quote/invoice portals; document numbers and statuses are preserved/translated safely
  [/^Invoice\s+(.+)$/i, number => `فاتورة مبيعات ${number}`],
  [/^Quote\s+(.+)$/i, number => `عرض سعر ${number}`],
  [/^Quotation\s+(.+)$/i, number => `عرض سعر ${number}`],
  [/^This invoice is currently\s+(.+)\.$/i, status => `حالة الفاتورة حاليًا: ${statusInArabic(status)}.`],
  [/^This quote is currently\s+(.+)\.$/i, status => `حالة عرض السعر حاليًا: ${statusInArabic(status)}.`],
  [/^Quote\s+(.+)\s+successfully$/i, status => `تم تحديث عرض السعر إلى «${statusInArabic(status)}» بنجاح`],
  [/^Failed to generate PDF:\s*(.+)$/i, error => `تعذر إنشاء ملف PDF: ${error}`],
  [/^Number:\s*(.+)$/i, number => `الرقم: ${number}`],
  [/^Reference:\s*(.+)$/i, reference => `المرجع: ${reference}`],
  [/^Due Date:\s*(.+)$/i, date => `تاريخ الاستحقاق: ${date}`],
  [/^Issue Date:\s*(.+)$/i, date => `تاريخ الإصدار: ${date}`],
  [/^Expiry Date:\s*(.+)$/i, date => `تاريخ الانتهاء: ${date}`],

  // Printable-document labels with captured business data left untouched
  [/^Phone:\s*(.+)$/i, phone => `الهاتف: ${phone}`],
  [/^Email:\s*(.+)$/i, email => `البريد الإلكتروني: ${email}`],
  [/^VAT:\s*(.+)$/i, vat => `الرقم الضريبي: ${vat}`],
  [/^Customer VAT:\s*(.+)$/i, vat => `الرقم الضريبي للعميل: ${vat}`],
  [/^Lot:\s*(.+)$/i, lot => `التشغيلة: ${lot}`],
  [/^Delivered on:\s*(.+)$/i, date => `تم التسليم في: ${date}`],
  [/^Amount Paid\s+(.+)$/i, amount => `المبلغ المدفوع ${amount}`],
  [/^Amount Due\s+(.+)$/i, amount => `المبلغ المستحق ${amount}`],
];
